import { render, staticRenderFns } from "./circlepart.vue?vue&type=template&id=74a99bd4&scoped=true"
import script from "./circlepart.vue?vue&type=script&lang=js"
export * from "./circlepart.vue?vue&type=script&lang=js"
import style0 from "./circlepart.vue?vue&type=style&index=0&id=74a99bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a99bd4",
  null
  
)

export default component.exports